import { ArrowR12 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './styles.css';

type TChatHeaderUserCardButton = {
  onClick: () => void;
};

export const ChatHeaderUserCardButton: React.VFC<TChatHeaderUserCardButton> = ({ onClick }) => {
  return (
    <a className={styles['arrow']} data-testid="ChatHeaderUserCardButton">
      <ArrowR12 onClick={onClick} color="gray60_100" />
    </a>
  );
};
